module.exports = __webpack_public_path__ + "static/media/21PerformancePhotos.4d2f4fac.jpeg";